import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
    ISatisfactorySurveryMapStateProps,
    ISatisfactorySurveryMapDispatchProps
} from "./Types";
import { ApplicationState } from "../../store";
import { SatisfactorySurvery } from "./SatisfactorySurvery.component";
import {
    getLanguageCode,
    getLanguageResourceGeneralStrings
} from "../../store/LanguageLocale/selector";
import { SatisfactoryLevel, TypeOfFinalTransaction, ErrorCodes } from "../../dtos/KioskDtos.dtos";

import { Routes } from "../../constants/routes";
import { postSurveyResultToServer } from "../../sagas/RequestSagas/actions";
import { getSurveyErrorCode } from "../../store/Survey/selectors";
import { push } from "../../store/Routing/actions";

const mapStateToProps = (state: ApplicationState): ISatisfactorySurveryMapStateProps => {
    return {
        lang: getLanguageCode(state.localeText),
        text: getLanguageResourceGeneralStrings(state.localeText),
        errorCode: getSurveyErrorCode(state),
        surveySubmitted: state.survey.surveySent,
        typeOfFinalTransactionCompleted: state.survey.typeOfFinalTransactionCompleted
    }
};

const mapDispatchToProps = (dispatch: Dispatch): ISatisfactorySurveryMapDispatchProps => ({
    postAnswer: (level: SatisfactoryLevel, type: TypeOfFinalTransaction, errorCode: ErrorCodes) => dispatch(postSurveyResultToServer(level, type, errorCode)),

    exit: () => dispatch(push(Routes.introduction)),
});

export default connect<ISatisfactorySurveryMapStateProps, ISatisfactorySurveryMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(SatisfactorySurvery);


// WEBPACK FOOTER //
// ./src/components/SatisfactorySurvery/SatisfactorySurvery.container.ts